import React from "react";
import "./TypeButton.scss";

type Props = {
  type: string;
  isDetail?: boolean;
};

const parseText = (type: string): string => {
  const obj: any = {
    e_notice: "긴급공지",
    notice: "공지",
    update: "업데이트",
    event: "이벤트",
    etc: "기타",
  };
  return obj[type];
};

const TypeButton: React.FC<Props> = ({ type, isDetail }) => {
  const value: string = React.useMemo(() => parseText(type), [type]);
  return (
    <p className={`TypeButton ${type} ${isDetail ? "detail" : ""}`}>{value}</p>
  );
};

export default React.memo(TypeButton);
